export interface GreetingWorkflowButtonDef {
    label: string;
    subtitle: string;
    iconName?: string;
    actionKey: string;
    wip?: string;
}

export const CHATBOT_GREETING_WORKFLOWS: Record<string, GreetingWorkflowButtonDef[]> = {
    dashboard: [
        {
            label: 'Show me what\'s new on the market',
            subtitle: 'Get the latest new market inventory',
            actionKey: 'showNewMarketInventory',
        },
        {
            label: 'Generate a comp report',
            subtitle: 'Build a comparative market analysis',
            actionKey: 'generateCompReport',
            wip: 'Comp report workflow not implemented in chatbot',
        },
        {
            label: 'Show me customers with new activity',
            subtitle: 'See which customers need your attention',
            actionKey: 'showCustomersWithActivity',
        },
    ],
    'building-details': [
        {
            label: 'Create a comp report for this building',
            subtitle: 'Compare listings in this building',
            actionKey: 'buildingCompReport',
        },
        {
            label: 'Show me a buyer profile for this building',
            subtitle: 'See the ideal buyer for this building',
            actionKey: 'buildingBuyerProfile',
        },
        {
            label: 'Give me insights for this building',
            subtitle: 'AI-generated insights for this building',
            actionKey: 'buildingInsights',
        },
        {
            label: 'Tell me what\'s on the market in this building',
            subtitle: 'See current listings in this building',
            actionKey: 'buildingMarketInventory',
        },
        {
            label: 'Create a building brochure',
            subtitle: 'Generate a building and neighborhood brochure',
            actionKey: 'buildingBrochure',
        },
    ],
    'neighborhood-details': [
        {
            label: 'Give me insights for this neighborhood',
            subtitle: 'AI-generated insights for this neighborhood',
            actionKey: 'neighborhoodInsights',
        },
        {
            label: 'Show me a buyer profile for this neighborhood',
            subtitle: 'See the ideal buyer for this neighborhood',
            actionKey: 'neighborhoodBuyerProfile',
        },
        {
            label: 'Tell me what\'s currently on the market in this neighborhood',
            subtitle: 'See current listings in this neighborhood',
            actionKey: 'neighborhoodMarketInventory',
        },
        {
            label: 'Create a neighborhood brochure',
            subtitle: 'Generate a brochure for this neighborhood',
            actionKey: 'neighborhoodBrochure',
            wip: 'Neighborhood brochure workflow not implemented in chatbot',
        },
    ],
};
